// extracted by mini-css-extract-plugin
export var labelWrapper = "_ew-0";